import { jwtDecode } from 'jwt-decode';

export const getUserRole = () => {
  const auth = JSON.parse(localStorage.getItem('auth'));
  if (!auth) {
    return null;
  }
  //console.log('test ',auth);
  
  const decodedToken = jwtDecode(auth.token);
  //console.log('decoded', decodedToken);
  
  return decodedToken.role;
};

// Capitalize the first letter of each word in a string
export const capitalize = (str) => {
  if (!str) return '';
  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};